<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos del decisor (representante)" title-color="dark" collapseAction >
      <div v-if="empresa">
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">DNI/CIF *</span>
            </div>
            <div>
              <vx-input-group>
                <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniDecisor" v-model="decisor.dni" 
                  v-on:keyup="borrarCamposDecisor" @input="v => { decisor.dni = v.toUpperCase()}"/>
                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona('DECISOR')" />
                  </div>
                </template>
              </vx-input-group>
              <span class="text-danger text-sm"  v-show="errors.has('dniDecisor')">{{ errors.first('dniDecisor') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Cargo</span>
            </div>
            <div>
              <vs-input class="w-full" name="cargo" v-model="operacionPersonaDecisor.cargo" @input="v => { operacionPersonaDecisor.cargo = v.toUpperCase()}"/>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">Nombre *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreDecisor" v-model="decisor.nombre" 
                :disabled="decisorDisabled" @input="v => { decisor.nombre = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('nombreDecisor')">{{ errors.first('nombreDecisor') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">Apellidos *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="APELLIDOS" v-validate="'required'" name="apellidos" v-model="decisor.apellidos" 
                :disabled="decisorDisabled" @input="v => { decisor.apellidos = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('apellidos')">{{ errors.first('apellidos') }}</span>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">Móvil de contacto *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
                name="telefonoDecisor" v-model="operacionPersonaDecisor.telefono" />
              <span class="text-danger text-sm"  v-show="errors.has('telefonoDecisor')">{{ errors.first('telefonoDecisor') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">E-mail *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="E-MAIL" v-validate="'email'" name="emailDecisor" v-model="operacionPersonaDecisor.email" />
              <span class="text-danger text-sm"  v-show="errors.has('emailDecisor')">{{ errors.first('emailDecisor') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <vs-alert color="danger" icon-pack="feather" icon="icon-info">
          <span>El cliente no es una empresa, por lo que no existe decisor.</span>
        </vs-alert>
      </div>
    </vx-card>

    <popup-buscar-persona :popupProps="popupProps" @aceptar="popupBuscarPersonaAction" ref="consultarDni" />

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button v-if="empresa" class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import personasStore from '@/store/gestion/personas/index.js'

import popupBuscarPersona from '@/views/common-components/popupBuscarPersona'

export default {
  name: 'OperacionesEditDecisor',
  components: {
    popupBuscarPersona
  },
  data () {
    return {
      operacion: {},
      operacionPersonaDecisor: {
        telefono: null,
        email: null
      },
      decisor: {},
      decisorId: null,
      decisorCargo: null,
      decisorTelefono: null,
      decisorEmail: null,
      decisorIgualCliente: null,

      // Propiedades para deshabilitar campos que se poden obter si a persoa xa existe na BD
      decisorDisabled: true,
      movilDecisorDisabled: true,
      emailDecisorDisabled: true,
      
      // popupBuscarPersona
      popupProps: {
        activo: false,
        dni: null,
        relacion: ''  // Relación da persoa coa operación: CLIENTE, DECISOR ou TITULAR
      },
      empresa: null,
      existeDecisorEnOperacionPersona: true
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any()|| this.decisor.dni === null || this.decisor.dni === undefined 
        || this.decisor.nombre === null || this.decisor.nombre === undefined 
        || this.decisor.apellidos === null || this.decisor.apellidos === undefined 
        || this.operacionPersonaDecisor.telefono === null || this.operacionPersonaDecisor.telefono === undefined 
        || this.operacionPersonaDecisor.email === null || this.operacionPersonaDecisor.email === undefined) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    async guardar () {
      if (!this.validateForm) return

      let cambios = false  // Para saber si se cambiou algún dato e hai que recargar a operación no State
      let errorAlGuardar = false  // Para saber si se produce algún erro gardando o formulario

      // O DNI introducido non se atopou na BD (this.decisorId === null)
      if (this.decisorId === null) {
        this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
        cambios = true
          
        // Construimos un novo obxecto Persona e dámola de alta na BD
        const p = {}
        p.dni = this.decisor.dni
        p.nombre = this.decisor.nombre
        p.apellidos = this.decisor.apellidos
        p.fechaNacimiento = null

        errorAlGuardar = await this.$store.dispatch('personasStore/addPersona', p)
          .then((response)   => { 
            this.decisorId = response.data.id
          })
          .catch((error) => {
            this.showUpdateError(error)
            return true
          })

        if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

        // Construimos o obxecto OperacionPersona para actulizalo ou crealo (se non existía o rexistro en operacion_persona) cos datos da nova persoa
        const op = {}
        op.operacion = `/api/operacions/${this.operacion.id}`
        op.persona = `/api/personas/${this.decisorId}`
        op.relacion = 'DECISOR'
        op.cargo = this.operacionPersonaDecisor.cargo
        op.telefono = this.operacionPersonaDecisor.telefono
        op.email = this.operacionPersonaDecisor.email
        op.direccion = null

        if (this.existeDecisorEnOperacionPersona) {
          op.id = this.operacionPersonaDecisor.id
          errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', op)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
        } else {
          op.relacion = 'DECISOR'
          errorAlGuardar = await this.$store.dispatch('operacionesStore/addOperacionPersona', op)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })          
        }

      // Se non se trata dunha nova persoa, senón que a persoa cambiouse pero existe na BD
      // ou se modificou algún outro dato da pantalla
      } else if ((this.operacionPersonaDecisor.persona !== undefined && this.decisorId !== this.operacionPersonaDecisor.persona.id) || 
        (this.decisorCargo !== this.operacionPersonaDecisor.cargo || this.decisorTelefono !== this.operacionPersonaDecisor.telefono
        || this.decisorEmail !== this.operacionPersonaDecisor.email)) {
        this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
        cambios = true

        // Construimos o obxecto OperacionPersona para actulizalo ou crealo (se non existía o rexistro en operacion_persona) cos datos da nova persoa
        const op = {}
        op.operacion = `/api/operacions/${this.operacion.id}`
        op.persona = `/api/personas/${this.decisorId}`
        op.relacion = 'DECISOR'
        op.cargo = this.operacionPersonaDecisor.cargo
        op.telefono = this.operacionPersonaDecisor.telefono
        op.email = this.operacionPersonaDecisor.email
        op.direccion = null

        if (this.existeDecisorEnOperacionPersona) {
          op.id = this.operacionPersonaDecisor.id
          errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', op)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
        } else {
          errorAlGuardar = await this.$store.dispatch('operacionesStore/addOperacionPersona', op)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })          
        }
      }

      // Se se fixeron cambios actualizamos a operación no State
      if (cambios) {
        if (!errorAlGuardar) {
          await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
          this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          this.showUpdateSuccess('DECISOR ACTUALIZADO', 'Los datos del decisor han sido guardados correctamente.')
        }
      } else {
        this.showUpdateSuccess('DECISOR ACTUALIZADO', 'Los datos del decisor han sido guardados correctamente.')
      }
    },
    showUpdateSuccess (titulo, texto) {
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showUpdateError (error) {
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    borrarCamposDecisor () {
      // Habilitamos os campos (con eles deshabilitanos cambiar os valores compórtase erróneamente)
      this.decisorDisabled = false
      this.movilDecisorDisabled = false
      this.emailDecisorDisabled = false
      // Borramos os campos
      this.decisorId = null
      this.decisor.nombre = null
      this.decisor.apellidos = null
      this.operacionPersonaDecisor.telefono = null
      this.operacionPersonaDecisor.email = null
      // Deshabilitamos os campos
      this.decisorDisabled = true
      this.movilDecisorDisabled = true
      this.emailDecisorDisabled = true
    },
    abrirPopupBuscarPersona (relacion) {
      this.popupProps.relacion = relacion
      if (!this.errors.has('dniDecisor') && this.decisor.dni !== null && this.decisor.dni !== undefined) {
        this.popupProps.dni = this.decisor.dni
        this.decisorId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
        // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
        this.borrarCamposDecisor()
        // Chamamos ao método do popup
        this.$refs.consultarDni.consultarDni()
      }
    },
    popupBuscarPersonaAction (persona) {
      this.popupProps.activo = false  // Pechamos o popup
      if (persona.existe) {
        this.decisorId = persona.personaId // Asignamos o id da persoa atopada para gardar na operación
        this.decisorDisabled = false
        this.decisor.nombre = persona.nombre
        this.decisor.apellidos = persona.apellidos
        this.decisorDisabled = true
        if (persona.movil !== 'NUEVO') {  //Se se seleccionou un móbil cubrimos o campo, senón habilitámolo para que o usuario o engada
          this.movilDecisorDisabled = false
          this.operacionPersonaDecisor.telefono = persona.movil
          this.movilDecisorDisabled = true
        } else {
          this.movilDecisorDisabled = false
        }
        if (persona.email !== 'NUEVO') {  //Se se seleccionou un e-mail cubrimos o campo, senón habilitámolo para que o usuario o engada
          this.emailDecisorDisabled = false
          this.operacionPersonaDecisor.email = persona.email
          this.emailDecisorDisabled = true
        } else {
          this.emailDecisorDisabled = false
        }
      } else {
        this.decisorDisabled = false
        this.movilDecisorDisabled = false
        this.emailDecisorDisabled = false
      }
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))

    // Para mostrar ou ocultar o DIV cos datos de decisor dependendo de si é unha empresa ou non
    this.operacion.tipoCliente === 'EMPRESA' ? this.empresa = true : this.empresa = false

    // Si existe 'decisor' na operación...
    if (this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR') !== undefined) {
      this.operacionPersonaDecisor = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR')))
      this.decisor = JSON.parse(JSON.stringify(this.operacionPersonaDecisor.persona))
      this.decisorId = this.operacionPersonaDecisor.persona.id
      this.decisorCargo = this.operacionPersonaDecisor.cargo
      this.decisorTelefono = this.operacionPersonaDecisor.telefono
      this.decisorEmail = this.operacionPersonaDecisor.email
    } else {
      this.existeDecisorEnOperacionPersona = false
    }
  },
  destroyed () {
    // Poñemos a FALSE a propiedade que habilita a pestaña Decisor cando se cambia o tipo de cliente a EMPRESA
    this.$store.dispatch('operacionesStore/crearDecisor', false)
  }
}
</script>